import React, { useEffect, useState } from "react";
import { Nav, Container, Row, Col, Image, Button, Spinner } from "react-bootstrap";
import Section from "../../Components/Section/Section";
import Heading from "../../Components/Heading/Heading";
import {
  LuArchive,
  LuArrowRight,
  LuBanknote,
  LuPencil,
  LuShoppingBag,
  LuTruck,
} from "react-icons/lu";
import { IconType } from "react-icons";
import storeImage from "../../assets/images/shop2.png";
import { Link, useNavigate } from "react-router-dom";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import moment from "moment";
import { My_Store, Store_Dashboard_Summary, Store_Revenue } from "../../Api";
import { StoreDashboardSummary } from "../../Api/apis/types/store.types";
import { useTranslation } from "react-i18next";
import { base_url } from "../../Api/ApiConst";
import { toast } from "react-toastify";
import { getImageUrl } from "../../Utils/imageUtils";
import StoreCarousel from "../../Components/StoreCarousel/StoreCarousel";
import StoreBannerFallback from "../../Components/StoreCarousel/StoreBannerFallback";
import { useDispatch } from "react-redux";
import { INITIAL_TAB } from "../../Redux/User";

interface StatCardProps {
  title: string;
  icon: IconType;
  value?: React.ReactNode;
  subtext?: React.ReactNode;
  onViewAll?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  icon: Icon,
  value,
  subtext,
  onViewAll,
}) => (
  <div className="bg-white rounded-4 border border-1 border-light-subtle p-4 h-100 d-flex flex-column">
    <div className="d-flex justify-content-between align-items-start mb-3">
      <span className="text-uppercase text-secondary small fw-semibold">
        {title}
      </span>
      <span
        className="bg-primary-subtle text-primary rounded-3 d-flex align-items-center justify-content-center"
        style={{ width: 40, height: 40 }}
      >
        <Icon size={18} />
      </span>
    </div>
    {value !== undefined && <div className="fs-2 fw-bold mb-1">{value}</div>}
    {subtext && <div className="text-secondary small">{subtext}</div>}
    {onViewAll && (
      <button
        type="button"
        className="btn btn-link p-0 mt-auto pt-3 ms-auto text-decoration-none small d-flex align-items-center gap-1"
        onClick={onViewAll}
      >
        View all <LuArrowRight size={12} />
      </button>
    )}
  </div>
);

const StoreDashboard: React.FC = () => {
  const { t, i18n } = useTranslation();

    const title: string = 'Privacy Policy';
  const [storeName, setStoreName] = useState<string | null>("");
  const [label, setLabel] = useState("");
  const [userTokens, setUserTokens] = useState<any>("");
  const [admission, setAdmission] = useState<any>("");
  const [storeRevenue, setStoreRevenue] = useState("");
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [selectedDateType, setSelectedDateType] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [storeId, setStoreId] = useState<string | null>("");
  const [storeLogo, setStoreLogo] = useState<any>("");
  const [storeType, setStoreType] = useState<string | null>(null);

  const [fromDate, setFromDate] = useState<any>(moment().format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState<any>(moment().format("YYYY-MM-DD"));

  const [summary, setSummary] = useState<StoreDashboardSummary | null>(null);
  const [summaryLoading, setSummaryLoading] = useState(true);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleGetStoreRevenue = async () => {
    try {
      const payload = {
        from_date: fromDate,
        till_date: toDate,
        store_id: storeId,
      };
      const response: any = await Store_Revenue(payload);

      if (!response?.error) {
        setStoreRevenue(response.data?.revenue_data?.total_amount ?? 0);
        // console.log("data----->", response?.revenue_data?.total_amount);
      }
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      console.log(error);
    }
  };

  const fetchSummary = async () => {
    try {
      const response = await Store_Dashboard_Summary();
      setSummary(response.data.data);
    } catch (error) {
      console.log("Error fetching dashboard summary", error);
    } finally {
      setSummaryLoading(false);
    }
  };

  const renderCount = (count?: number) => {
    if (summaryLoading) return <Spinner animation="border" size="sm" />;
    return count?.toLocaleString() ?? "-";
  };

  const handleOnDayPress = (dayObject: any) => {
    const formatedDate = moment(dayObject?.dateString).format("DD-MM-YYYY");

    if (selectedDateType == "from") {
      setFromDate(formatedDate);
    } else {
      setToDate(formatedDate);
    }

    setShowModal(false);
  };

  const applyDateRange = () => {
    const today = moment();
    const isFromDateToday = moment(fromDate, "YYYY-MM-DD").isSame(today, "day");
    const isToDateToday = moment(toDate, "YYYY-MM-DD").isSame(today, "day");

    if (isFromDateToday && isToDateToday) {
      setLabel(t("storeDashboard.todaysSale"));
    } else {
      setLabel(t("storeDashboard.sales"));
    }
    // console.log("store id", storeId);
    if (!storeId) return;
    setShowLoader(true);
    handleGetStoreRevenue();
  };

  useEffect(() => {
    applyDateRange();
  }, [storeId]);

  const handleApply = () => {
    if (moment(fromDate).isAfter(moment(toDate))) {
      toast.error("From date cannot be after To date");
      return;
    }
    applyDateRange();
  };

  const handleFromDateClick = (dateType: string) => {
    setSelectedDateType(dateType);
    setShowModal(true);
  };

  const toggleModal = () => {
    setSelectedDateType("");
    setShowModal((prev: boolean) => !prev);
  };

  const handleAPI = async (check: any) => {
    const userTokens = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
    // console.log("in Handle API", userTokens);

    try {
      const response = await My_Store(userTokens);
      if (response && response.status === 200) {
        // console.log(response.data.my_stores[0], "storeImage============>");
        setAdmission(response.data.my_stores[0].admission);
        localStorage.setItem(
          STORAGE_CONSTANTS.STORE_NAME,
          response.data.my_stores[0].store_name
        );
        localStorage.setItem(
          STORAGE_CONSTANTS.STORE_STATUS,
          response.data.my_stores[0].admission
        );
        localStorage.setItem(
          STORAGE_CONSTANTS.STORE_ID,
          response.data.my_stores[0].id
        );
        localStorage.setItem(
          STORAGE_CONSTANTS.STORE_LOGO,
          response.data.my_stores[0].logo
        );
        localStorage.setItem(
          STORAGE_CONSTANTS.AREA_PIN,
          response.data.my_stores[0].service_area_pin_code
        );
        setStoreName(response.data.my_stores[0].store_name);
        setStoreId(String(response.data.my_stores[0].id));
        setStoreLogo(response.data.my_stores[0].logo);
        setStoreType(response.data.my_stores[0].store_type ?? null);

        if (response?.data?.my_stores[0]?.admission === "Approve") {
          if (check === "ord") {

            navigate("/orders");
          } else if (check === "int_ord") {
            navigate("/integrated-orders");
          } else if (check === "prod") {
            navigate("/products");
          }
        } else {
          toast.error("Store is not approved");
        }

      } else {
        console.log("Error fetching My Store details");
      }
    } catch (error) {
      console.log("Error fetching My Store details", error);
    }
  };

  useEffect(() => {
    let userToken = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN)
    if (userToken) {
      handleAPI("none")
      fetchSummary();
    } else {
      setSummaryLoading(false);
    }
  }, [])

  useEffect(() => {
    setStoreName(localStorage.getItem(STORAGE_CONSTANTS.STORE_NAME));
    setStoreId(localStorage.getItem(STORAGE_CONSTANTS.STORE_ID));
    setStoreLogo(localStorage.getItem(STORAGE_CONSTANTS.STORE_LOGO));
    setUserTokens(localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN));
    // setAdmission(localStorage.getItem(STORAGE_CONSTANTS.STORE_STATUS));
    // Scroll to the top when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const handleOrders = () => {
    handleAPI("ord")

  };

  const handleIntegratedOrders = () => {
    handleAPI("int_ord");
  };

  const handleProducts = async () => {
    handleAPI("prod")
  };

  const handleStoreCarouselEdit = () => {
    dispatch(INITIAL_TAB("StoreCarousel"))
    navigate("/profile")
  }


  return (
    <Section className="storeDashboard" style={{ backgroundColor: "var(--white-color)" }}>
      <Container className="py-4">
        {/* Store header */}
        <div className="bg-white rounded-4 shadow-sm p-4 d-flex align-items-center gap-3 mb-5">
          <Image
            src={
              storeLogo && storeLogo !== "null" ? getImageUrl(storeLogo) : storeImage
            }
            rounded
            className="flex-shrink-0 object-fit-cover"
            style={{ width: 64, height: 64 }}
          />
          <div className="min-w-0">
            <div className="text-secondary small">
              {t("storeDashboard.hello")},
            </div>
            <h2 className="fw-bold mb-0 text-truncate">{storeName}</h2>
          </div>
        </div>

        {/* Store carousel */}
        <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
          <div>
            <h4 className="fw-semibold mb-1">Store Carousel</h4>
            <p className="text-secondary small mb-0">
              This is what your customers see on your shop
            </p>
          </div>
          <Button onClick={handleStoreCarouselEdit} size="sm" className="d-flex gap-2 align-items-center flex-shrink-0">
            <LuPencil />
            Edit
          </Button>
        </div>
        <div className="mb-5">
          <StoreCarousel
            fallbackContent={
              <StoreBannerFallback storeName={storeName} storeType={storeType} />
            }
          />
        </div>

        

        {/* Overview */}
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
          <h4 className="fw-semibold mb-0">Overview</h4>
          <div className="d-flex flex-wrap align-items-center gap-2">
            <div className="input-group input-group-sm w-auto">
              <span className="input-group-text bg-white text-uppercase text-secondary small">
                {t("storeDashboard.from")}
              </span>
              <input
                type="date"
                className="form-control border-start-0"
                value={fromDate}
                max={toDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <span className="text-secondary">–</span>
            <div className="input-group input-group-sm w-auto">
              <span className="input-group-text bg-white text-uppercase text-secondary small">
                {t("storeDashboard.to")}
              </span>
              <input
                type="date"
                className="form-control border-start-0"
                value={toDate}
                min={fromDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
            <Button
              size="sm"
              className="px-4"
              onClick={handleApply}
              disabled={showLoader || !fromDate || !toDate}
            >
              Apply
            </Button>
          </div>
        </div>

        <Row className="g-3">
          <Col xs={12} sm={6} lg={3}>
            <StatCard
              title={label}
              icon={LuBanknote}
              value={
                showLoader ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  `Rs. ${Number(storeRevenue || 0).toLocaleString()}`
                )
              }
            />
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <StatCard
              title={t("storeDashboard.order")}
              icon={LuShoppingBag}
              value={renderCount(summary?.total_orders)}
              onViewAll={handleOrders}
            />
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <StatCard
              title="Integrated Orders"
              icon={LuTruck}
              value={renderCount(summary?.total_integrated_orders)}
              onViewAll={handleIntegratedOrders}
            />
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <StatCard
              title={t("storeDashboard.products")}
              icon={LuArchive}
              value={renderCount(summary?.total_products)}
              onViewAll={handleProducts}
            />
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default StoreDashboard;
